<template>
      <!-- Sezione FC6 
      <div class="contatti-container">
        <div class="titolo-card">
          <h1>Campagne Fc6</h1>
        </div>
        <table>
          <thead>
            <tr>
              <th>Telefono</th>
              <th>Stato</th>
              <th>Note</th>
              <th>Operatore</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="contatto in contatti" :key="contatto.id">
              <td>{{ contatto.telefono }}</td>
              <td>
                <select v-model="contatto.stato" @change="updateContactField(contatto, 'stato')">
                  <option value="">Seleziona uno stato</option>
                  <option value="inviato messaggio">Inviato messaggio WA</option>
                  <option value="appuntamento telefonico">Appuntamento Telefonico</option>
                  <option value="appuntamento studio">Appuntamento studio</option>
                  <option value="interessato online">Interessato online</option>
                  <option value="da ricontattare">Da ricontattare</option>
                  <option value="non risponde">Non risponde</option>
                  <option value="ci pensa">Ci pensa</option>
                  <option value="non interessata">Non interessata</option>
                </select>
              </td>
              <td>
                <input type="text" v-model="contatto.note" @blur="updateContactField(contatto, 'note')" placeholder="Aggiungi nota" />
              </td>
              <td>{{ contatto.operatore }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      -->

      <!-- Sezione comunicazioni -->
      <div class="comunicazioni-container">
        <div class="titolo-card">
          <h1>Comunicazioni utente</h1>
        </div>

        <button @click="showModal = true" class="create-user-button staff-button-positive">
          Aggiungi Comunicazione <span class="material-icons">add_circle_outline</span>
        </button>

        <!-- Modale aggiornato -->
        <div v-if="showModal" class="modal-overlay">
          <div class="modal-content">
            <h3>Nuova Comunicazione</h3>
            <form @submit.prevent="addComunicazione">
              <label>
                Data e Ora:
                <input type="datetime-local" v-model="newComunicazione.data" required />
              </label>
              <label>
                Tipo:
                <select v-model="newComunicazione.tipo">
          <option value="telefonata">Chiamata</option>
          <option value="prima telefonata">Prima chiamata</option>
          <option value="whatsapp">Whatsapp</option>
          <option value="email">E-mail</option>
          <option value="live">Dal vivo</option>
          <option value="messaggio">Messaggio</option>
          <option value="check confronto">Check di confronto</option>
          <option value="check lavorare">Check lavorare</option>
          <option value="ricontatto intermedio">Ricontatto intermedio</option>
          <option value="ricontatto finale">Ricontatto finale</option>
          <option value="recupero clienti fermi">Recupero clienti fermi</option>
          <option value="altro">Altro</option>
                </select>
              </label>
              <label>
                Urgenza:
                <select v-model="newComunicazione.urgenza">
                  <option value="bassa">Bassa</option>
                  <option value="media">Media</option>
                  <option value="alta">Alta</option>
                </select>
              </label>
              <label>
                Note:
                <input type="text" v-model="newComunicazione.note" />
              </label>

              <label>
                Email Collaboratore/i:
                <input type="text" v-model="newComunicazione.assignedEmail" placeholder="Esempio: email1@mail.com, email2@mail.com" />
              </label>
              <label>
                Tipo Promemoria:
                <select v-model="newComunicazione.tipoPromemoria">
                  <option value="pubblico">Pubblico</option>
                  <option value="privato">Privato</option>
                </select>
              </label>
              <div class="modal-actions">
                <button class="staff-button-positive" type="submit">Salva</button>
                <button class="staff-button-cancel" type="button" @click="showModal = false">Annulla</button>
              </div>
            </form>
          </div>
        </div>

        <!-- Tabella comunicazioni aggiornata -->
        <table v-if="comunicazioni.length">
          <thead>
            <tr>
              <th>Azioni</th>
              <th>Data</th>
              <th>Orario</th>
              <th>Tipo</th>
              <th>Urgenza</th>
              <th>Note</th>
              <th>Stato</th>
              <th>Tipo Promemoria</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="com in comunicazioni"
              :key="com.id"
              :class="{ 'future-date': isFuture(com.data) }"
            >
              <td>
                <div class="action-icons">
                  <button @click="confirmDelete(com.id)" title="Cancella">
                    <span class="material-icons">delete</span>
                  </button>
                  <button @click="toggleReminderVisibility(com)" :title="com.visibilita ? 'Nascondi' : 'Mostra'">
                    <span class="material-icons">{{ com.visibilita ? 'visibility_off' : 'visibility' }}</span>
                  </button>
                </div>
              </td>
              <td>
                <input type="date" :value="getDateString(com.data)" @blur="updateReminderDate(com, $event.target.value, null)" />
              </td>
              <td>
                <input type="time" :value="getTimeString(com.data)" @blur="updateReminderDate(com, null, $event.target.value)" />
              </td>
              <td>
                <select v-model="com.tipo" @change="updateReminderField(com, 'tipo')">
          <option value="telefonata">Chiamata</option>
          <option value="prima telefonata">Prima chiamata</option>
          <option value="whatsapp">Whatsapp</option>
          <option value="email">E-mail</option>
          <option value="live">Dal vivo</option>
          <option value="messaggio">Messaggio</option>
          <option value="check confronto">Check di confronto</option>
          <option value="check lavorare">Check lavorare</option>
          <option value="ricontatto intermedio">Ricontatto intermedio</option>
          <option value="ricontatto finale">Ricontatto finale</option>
          <option value="recupero clienti fermi">Recupero clienti fermi</option>
          <option value="altro">Altro</option>
                </select>
              </td>
              <td>
                <select v-model="com.urgenza" @change="updateReminderField(com, 'urgenza')">
                  <option value="bassa">Bassa</option>
                  <option value="media">Media</option>
                  <option value="alta">Alta</option>
                </select>
              </td>
              <td>
                <input type="text" v-model="com.note" @blur="updateReminderField(com, 'note')" placeholder="Aggiungi nota" class="note-textarea" />
              </td>
              <td>
                <select v-model="com.fatto" @change="updateReminderField(com, 'fatto')">
                  <option value="si">Fatto</option>
                  <option value="da fare">Da fare</option>
                </select>
              </td>
              <td>
                <select v-model="com.tipoPromemoria" @change="updateReminderField(com, 'tipoPromemoria')">
                  <option value="pubblico">Pubblico</option>
                  <option value="privato">Privato</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else>Nessuna comunicazione trovata.</p>
      </div>
</template>

<script>
import { ref, watch, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  onSnapshot,
  deleteDoc,
  doc,
  where,
  updateDoc,
  getDocs,
  Timestamp
} from 'firebase/firestore';

export default {
  name: "ComunicazioniComponent",
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const showModal = ref(false);
    const comunicazioni = ref([]);
    const contatti = ref([]);
    const userEmailFromStore = ref('');
    const db = getFirestore();
    const store = useStore();

    const resetNewComunicazione = () => ({
      data: '',
      tipo: '',
      urgenza: '',
      note: '',
      assignedEmail: '',
      tipoPromemoria: 'pubblico',
      fatto: 'da fare'
    });

    const newComunicazione = ref(resetNewComunicazione());

    let unsubscribeComunicazioni = null;
    let unsubscribeContatti = null;

    const cleanupComunicazioniListener = () => {
      if (typeof unsubscribeComunicazioni === 'function') {
        unsubscribeComunicazioni();
        unsubscribeComunicazioni = null;
      }
    };

    const cleanupContattiListener = () => {
      if (typeof unsubscribeContatti === 'function') {
        unsubscribeContatti();
        unsubscribeContatti = null;
      }
    };

    const startComunicazioniListener = (userId) => {
      cleanupComunicazioniListener();
      comunicazioni.value = [];
      if (!userId) return;

      const q = query(
        collection(db, 'comunicazioni'),
        where('uid', '==', userId)
      );

      unsubscribeComunicazioni = onSnapshot(q, (snap) => {
        const items = snap.docs
          .map((d) => {
            const data = d.data();
            const parsedDate = parseDate(data.data);
            return {
              id: d.id,
              ...data,
              data: parsedDate || data.data || null,
            };
          })
          .sort((a, b) => {
            const ad = parseDate(a.data);
            const bd = parseDate(b.data);
            const aTime = ad ? ad.getTime() : 0;
            const bTime = bd ? bd.getTime() : 0;
            return aTime - bTime;
          });

        comunicazioni.value = items;
        console.log('👀 Comunicazioni aggiornate:', items);
      }, (error) => {
        console.error('Errore fetch comunicazioni:', error);
        comunicazioni.value = [];
      });
    };

    const startContattiListener = (email) => {
      cleanupContattiListener();
      contatti.value = [];
      const normalizedEmail = (email || '').trim();
      if (!normalizedEmail) return;

      const contactsQuery = query(collection(db, 'campagnaintegrazione'), where('email', '==', normalizedEmail));
      unsubscribeContatti = onSnapshot(contactsQuery, (snap) => {
        contatti.value = snap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      }, (error) => {
        console.error('Errore fetch contatti:', error);
        contatti.value = [];
      });
    };

    const updateContactField = async (contact, field) => {
      try {
        await updateDoc(doc(db, "campagnaintegrazione", contact.id), {
          [field]: contact[field]
        });
      } catch (error) {
        alert("Errore nell'aggiornamento del contatto");
      }
    };

    const sanitizeEmailList = (value = '') => value
      .split(',')
      .map(e => e.trim().toLowerCase())
      .filter(e => e.length > 0);

    const addComunicazione = async () => {
      if (!newComunicazione.value.data) {
        alert("Inserisci la data e l'ora.");
        return;
      }

      const parsedDate = new Date(newComunicazione.value.data);
      if (Number.isNaN(parsedDate.getTime())) {
        alert("Data non valida");
        return;
      }

      const assignedEmailList = sanitizeEmailList(newComunicazione.value.assignedEmail || '');
      const assignedEmailString = assignedEmailList.join(', ');

      if (assignedEmailList.length) {
        const isValid = await verifyAssignedUser(assignedEmailList);
        if (!isValid) {
          alert("Email assegnata non valida.");
          return;
        }
      }

      try {
        const docRef = await addDoc(collection(db, 'comunicazioni'), {
          uid: props.userId,
          data: Timestamp.fromDate(parsedDate),
          tipo: newComunicazione.value.tipo,
          urgenza: newComunicazione.value.urgenza,
          note: newComunicazione.value.note || '',
          userEmail: userEmailFromStore.value || '',
          assignedEmail: assignedEmailString,
          tipoPromemoria: newComunicazione.value.tipoPromemoria,
          fatto: newComunicazione.value.fatto,
          visibilita: true
        });

        console.log("✅ Comunicazione salvata con ID:", docRef.id);

        newComunicazione.value = resetNewComunicazione();
        showModal.value = false;
      } catch (error) {
        alert("Errore nel salvataggio.");
        console.error("🔥 Errore addComunicazione:", error);
      }
    };


const confirmDelete = async (id) => {
  if (!confirm("Sei sicuro di voler cancellare?")) return;

  try {
    await deleteDoc(doc(db, 'comunicazioni', id));
    comunicazioni.value = comunicazioni.value.filter(c => c.id !== id);
    console.log(`🗑️ Comunicazione ${id} eliminata`);
  } catch (error) {
    console.error("Errore durante la cancellazione:", error);
    alert("Errore durante la cancellazione.");
  }
};



const verifyAssignedUser = async (emails) => {
  const list = Array.isArray(emails) ? emails : sanitizeEmailList(emails);
  if (!list.length) return false;

  const chunks = [];
  for (let i = 0; i < list.length; i += 10) {
    chunks.push(list.slice(i, i + 10));
  }

  let found = 0;
  for (const chunk of chunks) {
    const q = query(collection(db, 'users'), where('email', 'in', chunk));
    const snap = await getDocs(q);
    found += snap.size;
  }

  return found > 0;
};


    const updateReminderField = async (com, field) => {
      try {
        await updateDoc(doc(db, 'comunicazioni', com.id), {
          [field]: com[field]
        });
      } catch (e) {
        console.error(`Errore aggiornamento ${field}:`, e);
      }
    };

    const toggleReminderVisibility = async (com) => {
      try {
        const newVal = !com.visibilita;
        await updateDoc(doc(db, 'comunicazioni', com.id), { visibilita: newVal });
        com.visibilita = newVal;
      } catch (e) {
        console.error("Errore visibilità:", e);
      }
    };

    const updateReminderDate = async (com, newDateStr, newTimeStr) => {
      try {
        const d = parseDate(com.data);
        if (!d) return;
        let year = d.getFullYear();
        let month = d.getMonth();
        let date = d.getDate();
        let hours = d.getHours();
        let minutes = d.getMinutes();

        if (newDateStr) {
          const [y, m, dd] = newDateStr.split('-').map(Number);
          year = y; month = m - 1; date = dd;
        }

        if (newTimeStr) {
          const [h, min] = newTimeStr.split(':').map(Number);
          hours = h; minutes = min;
        }

        const newDate = new Date(year, month, date, hours, minutes);
        await updateDoc(doc(db, 'comunicazioni', com.id), { data: newDate });
        com.data = newDate;
      } catch (e) {
        console.error("Errore updateReminderDate:", e);
      }
    };

    const parseDate = (field) => {
      if (!field) return null;
      if (field instanceof Date) return field;
      if (typeof field?.toDate === 'function') return field.toDate();

      if (typeof field === 'string') {
        const trimmed = field.trim();
        const datePattern = new RegExp('^(\\d{1,2})/(\\d{1,2})/(\\d{2,4})(?:[,\\s]+(\\d{1,2}):(\\d{2}))?$');
        const match = trimmed.match(datePattern);
        if (match) {
          const [, dd, mm, yyyyRaw, hh = '0', min = '0'] = match;
          const yyyy = yyyyRaw.length === 2 ? `20${yyyyRaw}` : yyyyRaw;
          const candidate = new Date(Number(yyyy), Number(mm) - 1, Number(dd), Number(hh), Number(min));
          if (!Number.isNaN(candidate.getTime())) return candidate;
        }
      }

      const parsed = new Date(field);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const getDateString = (value) => {
      const d = parseDate(value);
      if (!d) return '';
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const getTimeString = (value) => {
      const d = parseDate(value);
      if (!d) return '';
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    };

    const isFuture = (value) => {
      const d = parseDate(value);
      return !!(d && d.getTime() > Date.now());
    };

    watch(
      () => props.userId,
      async (userId) => {
        startComunicazioniListener(userId);
        if (!userId) {
          userEmailFromStore.value = '';
          cleanupContattiListener();
          return;
        }

        try {
          await store.dispatch('fetchUserDetails', userId);
          const retrievedEmail = store.getters.userEmail || '';
          userEmailFromStore.value = retrievedEmail;
          startContattiListener(retrievedEmail);
        } catch (error) {
          console.error('Errore fetchUserDetails:', error);
          userEmailFromStore.value = '';
          cleanupContattiListener();
        }
      },
      { immediate: true }
    );

    onUnmounted(() => {
      cleanupComunicazioniListener();
      cleanupContattiListener();
    });

    return {
      showModal,
      comunicazioni,
      contatti,
      newComunicazione,
      addComunicazione,
      confirmDelete,
      updateReminderField,
      updateReminderDate,
      toggleReminderVisibility,
      getDateString,
      getTimeString,
      updateContactField,
      isFuture
    };
  }
};
</script>



<style scoped>
/* Tabella */
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  margin-bottom: 70px;
}
th, td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}
tbody tr:nth-child(odd) {
  background-color: #f9f9f9;
}
tbody tr:nth-child(even) {
  background-color: #f1f1f1;
}
tbody tr.future-date {
  background-color: #d4edda !important; /* verde chiaro */
}

/* Sezione titoli */
.titolo-card {
  margin: 30px 0 10px;
}
.titolo-card h1 {
  font-size: 1.6rem;
  color: #222;
}


.create-user-button .material-icons {
  margin-left: 6px;
}

/* Icone azioni */
.action-icons {
  display: flex;
  gap: 6px;
  align-items: center;
}
.action-icons button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}
.action-icons button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.action-icons .material-icons {
  font-size: 20px;
  vertical-align: middle;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
    z-index: 1000;

}
.modal-content {
  padding: 20px;
  border-radius: 8px;
  width: 470px;
  margin-left: 220px;
}

.modal-actions { display: flex; gap: 10px; margin-top: 10px; }
.modal-content label { display: block; margin-bottom: 10px; }
.promemoria-container {
  margin-top: 60px;
  margin-bottom: 30px;
}

/* Note a capo */
.note-textarea {
  white-space: pre-wrap;
}

/* Responsive migliorato */
@media (max-width: 768px) {
  table, thead, tbody, th, td, tr {
    font-size: 14px;
  }
  .modal-content {
    padding: 20px;
  }
}
</style>
